import { defineMessages } from 'react-intl';

export default defineMessages({
    contactDetailsSuccessMsg: {
        id: 'accounts.summary.edit-contact-details-popup.Contact details are saved successfully',
        defaultMessage: 'Contact details are saved successfully'
    }
});
